var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { router } from '@inertiajs/react';
import { useRoute } from 'ziggy-js';
import AppLayout from '@/Layouts/AppLayout';
import Breadcrumb from '@/Jetstream/Breadcrumb';
import handleUnsavedChanges from "@/Utils/handleUnsavedChanges";
import useForm from "@/Utils/useForm";
import StepLayout from "./StepLayout";
import { ArrowUpTrayIcon } from "@heroicons/react/24/outline";
import JetLabel from "@/Jetstream/Label";
import JetInputError from "@/Jetstream/InputError";
import { Ziggy } from "@/ziggy";
export default function UploadStep(_a) {
    var certificate = _a.certificate, team = _a.team, branch = _a.branch, configs = _a.configs;
    var route = useRoute(Ziggy);
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var init = __assign(__assign({}, certificate), { _step: 0 });
    var uploadForm = useForm({
        file: "",
        ehc_config_id: 1,
    });
    var _c = useState(false), uploading = _c[0], setUploading = _c[1];
    function upload(e) {
        // setUploading(true);
        // uploadForm.setData('file', e.target.files[0])
        // uploadForm.data.file = e.target.files[0];
        //
        // uploadForm.post(route('team.branch.certificate.upload-ehc', {team, branch}), {
        //     forceFormData: true,
        //     preserveState: false,
        //     onSuccess: () => {
        //         setUploading(false);
        //         //router.get(route('team.branch.certificate-number.index', {team, branch}));
        //     },
        // });
    }
    var form = useForm(init);
    handleUnsavedChanges(form);
    function submit() {
        var fileElement = document.getElementById('file');
        if (fileElement.files && fileElement.files[0]) {
            setUploading(true);
            // Create FormData and append file and config
            var formData = new FormData();
            formData.append('file', fileElement.files[0]);
            formData.append('ehc_config_id', uploadForm.data.ehc_config_id);
            // Make the request using Inertia with the FormData
            router.post(route('team.branch.certificate.upload-ehc', { team: team, branch: branch }), formData, {
                forceFormData: true,
                onSuccess: function () {
                    setUploading(false);
                },
                onError: function () {
                    setUploading(false);
                },
            });
        }
    }
    useEffect(function () {
    });
    return (_jsx(AppLayout, __assign({ title: "Certificate", breadCrumb: _jsx(Breadcrumb, { team: team, branch: branch, client: certificate === null || certificate === void 0 ? void 0 : certificate.client, current: "Certificate" }), pageTitle: "Create EHC" }, { children: _jsxs(StepLayout, __assign({ team: team, branch: branch, certificate: certificate, form: form }, { children: [_jsx(JetLabel, { htmlFor: "ehc_config_id", value: "EHC document type to upload" }), _jsxs("select", __assign({ id: "ehc_config_id", name: "ehc_config_id", defaultValue: uploadForm.data.ehc_config_id, onChange: function (e) { return uploadForm.setData('ehc_config_id', e.currentTarget.value); }, className: "mt-1 block w-50 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm rounded-md" }, { children: [_jsx("option", __assign({ value: "" }, { children: "Select form type" })), configs === null || configs === void 0 ? void 0 : configs.map(function (config) { return (_jsx("option", __assign({ value: config.id }, { children: config.name }))); })] })), _jsx(JetInputError, { message: form.errors.product, className: "mt-2" }), _jsx("div", __assign({ className: "my-4" }, { children: _jsx("input", { type: "file", id: "file", className: "", accept: "application/pdf", onChange: function (e) { return upload(e); } }) })), _jsxs("button", __assign({ onClick: submit, id: "upload", 
                    // disabled={form.data.config==null}
                    // onClick={addRow}
                    className: "whitespace-nowrap cursor-pointer disabled:opacity-50 inline-flex items-center px-4 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-white ".concat(uploading ? "bg-gray-300" : "bg-sky-600 hover:bg-sky-700", " focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500") }, { children: [_jsx(ArrowUpTrayIcon, { className: "-ml-1 mr-2 h-4 w-4  inline-block", "aria-hidden": "true" }), !uploading && _jsx("span", { children: "Upload & continue" }), uploading && "Uploading..."] }))] })) })));
}
